import angular from 'angular';
import '../resources/external-service';

const module = angular.module('whyline.services.external-service', [
	'whyline.resources.external-service',
]);

let ExternalService;

class ExternalServiceService {
	static $inject = ['ExternalService'];

	constructor (ExternalServiceInjected) {
		ExternalService = ExternalServiceInjected;
	}

	Identify = (idNumber, gender) => {
		return ExternalService.Identify(idNumber, gender);
	}

	CommercialOfferMessage = (idCobis, idOrigin) => {
		return ExternalService.CommercialOfferMessage(idCobis, idOrigin);
	}

	OfficialOperator = (idCobis) => {
		return ExternalService.OfficialOperator(idCobis);
	}
}

module.exports = module.service('ExternalServiceService', ExternalServiceService);

